export default __webpack_public_path__ + "static/media/healthCare.dfb9bd34.jpg";